// extracted by mini-css-extract-plugin
export default {"makerGreen":"#385461","makerWhite":"white","header":"header_header__CDvKH"};